import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, MessageService } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { CASH_DESK_ACTION_TYPE, CashDeskAction } from "./cash-desk.action";
import { CASH_DESK_MESSAGE_CONTEXT } from "./cash-desk.const";
import { CashDeskService } from "./cash-desk.service";

@Injectable()
export class CashDeskEffect {
	get$ = createEffect(() =>
		this.actions$.pipe(
			ofType(CASH_DESK_ACTION_TYPE.get),
			switchMap(() =>
				this.service.get().pipe(
					map((response) => this.action.getSuccess(response)),
					catchError((error: AppError) => of(this.action.getFail(error)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[CASH_DESK_ACTION_TYPE.getFail]: CASH_DESK_MESSAGE_CONTEXT.get,
			}),
			this.messageService.mapClearByContext$({
				[CASH_DESK_ACTION_TYPE.get]: CASH_DESK_MESSAGE_CONTEXT.get,
			})
		)
	);

	constructor(
		private action: CashDeskAction,
		private actions$: Actions,
		private service: CashDeskService,
		private messageService: MessageService
	) {}
}
